export const PT_PT_KICORE = {
 "catalog": {
 "6 meses": "6 meses",
 "1 año": "1 ano",
 "Próximos 12 meses": "Próximos 12 meses",
 "El correo electrónico no es válido": "O endereço de e-mail não é válido",
 "la versión": "a versão",
 "publicada": "publicada",
 "Escribe la versión para confirmar": "Escreva a versão para confirmar",
 "Es la versión en distribución: al borrarla se retira también el puntero del canal y los equipos dejarán de recibir actualizaciones desde aquí.": "É a versão em distribuição: ao eliminá-la retira-se também o ponteiro do canal e os equipamentos deixarão de receber atualizações a partir daqui.",
 "Se eliminará el paquete y su manifest. Los equipos que ya la tengan instalada no se ven afectados.": "Serão eliminados o pacote e o seu manifest. Os equipamentos que já a tenham instalada não são afetados.",
 "Destino": "Destino",
 "Sin declarar": "Por declarar",
 "Destino de la versión": "Destino da versão",
 "Se publicó antes de declarar destino: se trata como dirigida a equipos": "Foi publicada antes de existirem destinos: é tratada como dirigida a equipamentos",
 "Esta versión se publicó sin declarar destino, así que se trata como dirigida a equipos": "Esta versão foi publicada sem destino, pelo que é tratada como dirigida a equipamentos",
 "Es la versión en distribución, así que el cambio tiene efecto de inmediato": "É a versão em distribuição, por isso a alteração tem efeito imediato",
 "No está en distribución: el cambio tendrá efecto cuando se publique": "Não está em distribuição: a alteração terá efeito quando for publicada",
 "¿A qué va dirigido este software?": "A que se destina este software?",
 "Equipos": "Equipamentos",
 "Aplicaciones de usuario": "Aplicações de utilizador",
 "Aplicación de usuario": "Aplicação de utilizador",
 "Core comprueba que el equipo esté registrado y con la suscripción en regla": "O Core verifica se o equipamento está registado e com a subscrição em ordem",
 "Se descarga sin comprobar nada en Core, porque no hay equipo que comprobar": "É descarregado sem qualquer verificação no Core, porque não há equipamento a verificar",
 "Destino del software": "Destino do software",
 "Cambiar destino": "Alterar destino",
 "Destino actualizado": "Destino atualizado",
 "Consultando el destino actual": "A consultar o destino atual",
 "Dejará de comprobarse la suscripción": "A subscrição deixará de ser verificada",
 "Cualquiera con un token válido podrá descargar este software, sin pasar por Core.": "Qualquer pessoa com um token válido poderá descarregar este software, sem passar pelo Core.",
 "El cambio se aplica a todas las versiones publicadas de este firmware": "A alteração aplica-se a todas as versões publicadas deste firmware",
 "Gestión de versiones de firmware OTA": "Gestão de versões de firmware OTA",
 "el firmware": "o firmware",
 "el canal": "o canal",
 "la variante": "a variante",
 "la carpeta": "a pasta",
 "Eliminar definitivamente": "Eliminar definitivamente",
 "Esta acción no se puede deshacer": "Esta ação não pode ser revertida",
 "Se eliminarán todas las versiones que cuelgan de esta ruta, incluidas las que estén en distribución. Los equipos dejarán de recibir actualizaciones desde aquí.": "Serão eliminadas todas as versões desta rota, incluindo as que estão em distribuição. Os equipamentos deixarão de receber atualizações a partir daqui.",
 "Se eliminará": "Será eliminado",
 "Calculando lo que contiene": "A calcular o conteúdo",
 "Escribe la ruta para confirmar": "Escreva a rota para confirmar",
 "Nuevo firmware": "Novo firmware",
 "Nuevo canal": "Novo canal",
 "Nueva variante": "Nova variante",
 "Nueva versión": "Nova versão",
 "Sin versiones publicadas": "Sem versões publicadas",
 "Se creará el firmware": "Será criado o firmware",
 "Se creará el canal": "Será criado o canal",
 "Se creará la variante": "Será criada a variante",
 "Las carpetas del almacén nacen con su primera versión": "As pastas do armazém nascem com a sua primeira versão",
 "Publicar una versión": "Publicar uma versão",
 "Publicar": "Publicar",
 "Nuevo o existente": "Novo ou existente",
 "Sin variante": "Sem variante",
 "Se publicará en": "Será publicada em",
 "Esa versión ya existe en este destino": "Essa versão já existe neste destino",
 "Solo se admiten letras, números, punto, guion y guion bajo": "Apenas se admitem letras, números, ponto, hífen e traço inferior",
 "Al publicarla, los equipos del canal empezarán a descargarla": "Ao publicá-la, os equipamentos do canal começarão a descarregá-la",
 "Subiendo el paquete": "A carregar o pacote",
 "Procesando en el servidor: checksum y manifest": "A processar no servidor: checksum e manifest",
 "Quitar": "Remover",
 "Buscar versión": "Procurar versão",
 "Ver como tabla": "Ver como tabela",
 "Ver como tarjetas": "Ver como cartões",
 "Ninguna versión coincide con la búsqueda": "Nenhuma versão corresponde à procura",
 "Subir un nivel": "Subir um nível",
 "Todos los firmwares": "Todos os firmwares",
 "Variante": "Variante",
 "canal": "canal",
 "canales": "canais",
 "variante": "variante",
 "variantes": "variantes",
 "O pulsa para elegirlo": "Ou clique para o escolher",
 "versión": "versão",
 "carpeta": "pasta",
 "Selecciona un firmware o un canal para ver su contenido": "Selecione um firmware ou um canal para ver o seu conteúdo",
 "Carpetas": "Pastas",
 "Versiones": "Versões",
 "versiones": "versões",
 "carpetas": "pastas",
 "Selecciona un canal para ver su contenido": "Selecione um canal para ver o seu conteúdo",
 "Esta carpeta solo contiene otras carpetas": "Esta pasta só contém outras pastas",
 "Firmwares": "Firmwares",
 "Firmware": "Firmware",
 "En distribución": "Em distribuição",
 "Poner en distribución": "Pôr em distribuição",
 "Ninguna versión en distribución": "Nenhuma versão em distribuição",
 "Eliminar y retirar de distribución": "Eliminar e retirar de distribuição",
 "Descargar": "Transferir",
 "Publicada": "Publicada",
 "Actualizar": "Atualizar",
 "Sin firmwares publicados": "Sem firmware publicado",
 "Selecciona un canal para ver sus versiones": "Selecione um canal para ver as suas versões",
 "Arrastra aquí el paquete de firmware": "Largue aqui o pacote de firmware",
 "O pulsa para elegirlo y completar los datos de la versión": "Ou clique para o escolher e preencher os dados da versão",
 "Un firmware o un canal nuevo nace al subir su primera versión": "Um firmware ou canal novo nasce ao carregar a sua primeira versão",
 "Variante (opcional)": "Variante (opcional)",
 "Distingue compilaciones del mismo canal, por ejemplo rpi4": "Distingue compilações do mesmo canal, por exemplo rpi4",
 "Versiones de firmware": "Versões de firmware",
 "Firmware OTA": "Firmware OTA",
 "Carpeta": "Pasta",
 "Publicada por": "Publicada por",
 "Archivo": "Ficheiro",
 "Tamaño": "Tamanho",
 "Acciones": "Ações",
 "Marcar latest": "Marcar como latest",
 "¿Marcar esta versión como latest?": "Marcar esta versão como latest?",
 "Los dispositivos del canal se actualizarán a esta versión": "Os dispositivos do canal serão atualizados para esta versão",
 "¿Borrar la versión latest?": "Eliminar a versão latest?",
 "Es la versión latest del canal: se borrará también el puntero": "É a versão latest do canal: o ponteiro também será eliminado",
 "Productos": "Produtos",
 "Subir versión": "Carregar versão",
 "Versión marcada como latest": "Versão marcada como latest",
 "Versión borrada correctamente": "Versão eliminada com sucesso",
 "Las carpetas se crean al subir su primera versión": "As pastas são criadas ao carregar a sua primeira versão",
 "Producto": "Produto",
 "Canal": "Canal",
 "Target (opcional)": "Target (opcional)",
 "Subcarpeta para diferenciar builds, por ejemplo rpi4": "Subpasta para diferenciar builds, por exemplo rpi4",
 "Campo obligatorio": "Campo obrigatório",
 "Seleccionar archivo": "Selecionar ficheiro",
 "Marcar como latest": "Marcar como latest",
 "Formato no permitido": "Formato não permitido",
 "Selecciona el archivo de firmware": "Selecione o ficheiro de firmware",
 "Versión subida correctamente": "Versão carregada com sucesso",
 "Subir": "Carregar",
 "Caducidad suscripción": "Expiração da assinatura",
 "Cambiar tarifa": "Alterar a tarifa",
 "Selecciona la tarifa destino para las tarjetas seleccionadas": "Selecione a tarifa de destino para os cart\u00f5es selecionados", 
 "Selecciona tarjetas y una tarifa": "Selecione cart\u00f5es e uma tarifa", 
 "Algunas tarjetas no se pudieron actualizar": "N\u00e3o foi poss\u00edvel atualizar alguns cart\u00f5es", 
 "Actualizadas": "Atualizadas", 
 "Fallidas": "Falhadas", 
"Error 404": "Erro 404", 
 "Detalles Administrativos": "Detalhes administrativos", 
 "Detalles  M2M": "M2M Detalhes", 
 "Search": "Procurar", 
 "Reset": "Reiniciar", 
 "Instalaci\u00f3n/Pedido": "Instala\u00e7\u00e3o/pedido", 
 "Cliente": "Cliente", 
 "Estado": "Estado", 
 "Desactivada": "Desabilitado", 
 "Activada": "Ativado", 
 "Inactiva nueva": "Novo inativo", 
 "Lista para activaci\u00f3n": "Lista para ativa\u00e7\u00e3o", 
 "Desconocido": "Um estranho", 
 "Consumo diario": "Consumo di\u00e1rio", 
 "Consumo mensual": "Consumo mensal", 
 "Comienzo \u00faltima conexi\u00f3n": "Inicie a \u00faltima conex\u00e3o", 
 "Fin \u00faltima conexi\u00f3n": "Encerta Enconssimento Final", 
 "Compa\u00f1\u00eda de red": "Empresa de rede", 
 "C\u00f3digo de pa\u00eds": "C\u00f3digo do pa\u00eds", 
 "Tipo de red": "Tipo de rede", 
 "Tipo de tarifa": "Tipo de taxa", 
 "Zona 1": "Zona 1", 
 "Sin asignar": "N\u00e3o atribu\u00eddo", 
 "Cambiar ciclo vida": "Mudar o ciclo de vida", 
 "Por favor, seleccione una opci\u00f3n": "Por favor, selecione uma op\u00e7\u00e3o", 
 "Desactivar": "Desativar", 
 "Activar": "Ativar", 
 "Test": "Teste", 
 "Estado GSM": "Estado GSM", 
 "Estado GPRS": "Estado GPRS", 
 "Buscar": "Procurar", 
 "Borrar": "Excluir", 
 "Nombre": "Nome", 
 "Descripci\u00f3n": "Descri\u00e7\u00e3o", 
 "UUID placa": "Crach\u00e1 UUID", 
 "Estado instalaci\u00f3n": "Status da instala\u00e7\u00e3o", 
 "Desconectada": "Desconectado", 
 "Conectada": "Conectado", 
 "Deshabilitada": "Desabilitado", 
 "Habilitada": "Habilitado", 
 "Detalles": "Detalhes", 
 "No se pudieron actualizar los datos": "N\u00e3o foi poss\u00edvel atualizar os dados", 
 "Pools actualizados correctamente": "Piscinas atualizadas com sucesso", 
 "Tarjetas activas / tarjetas totales": "Cart\u00f5es ativos / total de cart\u00f5es", 
 "Consumo del pool / Pool total": "Consumo da piscina / Total da piscina", 
 "Gasto estimado del pool": "Despesa estimada do pool", 
 "\u00daltima actualizaci\u00f3n": "\u00daltima atualiza\u00e7\u00e3o", 
 "Refrescar": "Atualizar", 
 "Actualizar token de acceso": "Atualizar token de acesso", 
 "Por favor, complete este campo": "Por favor, preencha este campo", 
 "Enviar": "Enviar", 
 "Placa creada correctamente": "Placa criada com sucesso", 
 "Placa actualizada correctamente": "Plaque mise \u00e0 jour avec succ\u00e8s", 
 "MAC err\u00f3nea": "MAC errado", 
 "SSID err\u00f3neo": "SSID errado", 
 "Nuevo kiwi": "Novo kiwi", 
 "Informaci\u00f3n de kiwi": "Informa\u00e7\u00f5es sobre Kiwis", 
 "Guardar": "Manter", 
 "UUID err\u00f3neo": "UUID errado", 
 "Nuevo kibox": "Novo kibox", 
 "Informaci\u00f3n de kibox con UUID": "Informa\u00e7\u00f5es Kibox com UUID", 
 "Informaci\u00f3n de kibox": "Informa\u00e7\u00f5es Kibox", 
 "Habr\u00e1 mas de una placa con ese uuid.\u00bfEst\u00e1 seguro de esto?": "Haver\u00e1 mais de uma placa com esse uuid. Voc\u00ea tem certeza disso?", 
 "Modelo placa": "Modelo de placa", 
 "Seleccionar opci\u00f3n": "Selecione a op\u00e7\u00e3o", 
 "Tarda demasiado en encenderse": "Demora muito para ligar", 
 "Usuario": "Do utilizador", 
 "Nombre de usuario": "Nome de usu\u00e1rio", 
 "Rol": "Papel", 
 "Organizaci\u00f3n": "Organiza\u00e7\u00e3o", 
 "Apellidos": "Sobrenomes", 
 "Email": "E-mail", 
 "Complete los campos obligatorios": "Preencha os campos obrigat\u00f3rios", 
 "Las contrase\u00f1as tienen que ser iguales": "As senhas devem ser iguais", 
 "Nombre de Usuario": "Nome de usu\u00e1rio", 
 "Correo electr\u00f3nico": "Correio eletr\u00f4nico", 
 "Contrase\u00f1a": "Senha", 
 "Repetir contrase\u00f1a": "Repetir a senha", 
 "Selecciona organizaci\u00f3n": "Selecione a organiza\u00e7\u00e3o", 
 "Nivel": "N\u00edvel", 
 "Selecciona un rol": "Selecione uma fun\u00e7\u00e3o", 
 "Superadministrador": "Super administrador", 
 "Administrador": "Administrador", 
 "Operador": "Operador", 
 "Visitante": "Visitante", 
 "Activo": "Ativo", 
 "Crear cuenta": "Criar uma conta", 
 "Inicio": "Come\u00e7ar", 
 "Nuevo equipo": "Novo time", 
 "Stock": "Estoque", 
 "Asignaciones": "Atribui\u00e7\u00f5es", 
 "Lista equipos": "Lista de equipamentos", 
 "Instalaciones": "Instala\u00e7\u00f5es", 
 "Listado M2M": "Listado M2M", 
 "Listado Pools": "Listado Pools", 
 "Soporte": "M\u00e9dio", 
 "Crear Usuario": "Criar usu\u00e1rio", 
 "Lista Usuarios": "Lista de usu\u00e1rios", 
 "error": "erro", 
 "Informaci\u00f3n de tarjeta M2M con icc": "Informa\u00e7\u00f5es do cart\u00e3o M2M com ICC", 
 "Alias": "Pseud\u00f4nimo", 
 "Life Cycle Status": "Status do ciclo de vida", 
 "Pais": "Pa\u00eds", 
 "Plan": "Plano", 
 "Estado Actual": "Estado atual", 
 "\u00daltimo evento": "\u00daltimo evento", 
 "Tecno.Conexi\u00f3n": "Techno.Connection", 
 "\u00daltima Conexi\u00f3n": "\u00daltima conex\u00e3o", 
 "Complete los campos": "Preencha os campos", 
 "Inicio de sesi\u00f3n exitoso": "Login bem-sucedido", 
 "Introduzca un nombre de usuario": "Digite um nome de usu\u00e1rio", 
 "Introduzca una contrase\u00f1a": "Insira uma senha", 
 "Iniciar sesi\u00f3n": "Iniciar sess\u00e3o", 
 "Eliminar": "Eliminar", 
 "Editar": "Editar", 
 "Asignar": "Atribuir", 
 "N\u00famero de serie err\u00f3neo": "N\u00famero de s\u00e9rie errado", 
 "Nuevo KiWi": "Novo KiWi", 
 "Pedido": "Ordem", 
 "N serie": "S\u00e9rie N", 
 "Fecha fabricaci\u00f3n": "Data de fabrica\u00e7\u00e3o", 
 "Estado de fabricaci\u00f3n": "Status de fabrica\u00e7\u00e3o", 
 "KiWi terminado": "KiWi finalizado", 
 "No se ha podido terminar": "N\u00e3o consegui terminar", 
 "Terminar": "Terminar", 
 "Version hardware": "Vers\u00e3o de hardware", 
 "Modelo": "Modelo", 
 "Tipo USB": "Tipo USB", 
 "Instalaci\u00f3n": "Instala\u00e7\u00e3o", 
 "Cliente kiconex": "Cliente kiconex", 
 "Cliente final": "Cliente final", 
 "N\u00famero de serie": "N\u00famero de s\u00e9rie", 
 "kiconex plan": "Plano kiconex", 
 "Nº dispositivos": "Nº de dispositivos", 
 "Cuadro": "Gr\u00e1fico", 
 "Placa terminada": "Placa acabada", 
 "Opcionales": "Opcionales", 
 "Notas": "Notas", 
 "Crear nuevo dispositivo": "Criar novo dispositivo", 
 "Bienvenido a kicore ¡la plataforma de gesti\u00f3n de Kiconex!": "Bem-vindo ao kicore, a plataforma de gest\u00e3o da Kiconex!", 
 "Ver en kiconex": "Veja em kiconex", 
 "ICC err\u00f3neo": "ICC errado", 
 "Nombre instalaci\u00f3n": "Nome da instala\u00e7\u00e3o", 
 "Nº serie": "N\u00famero de s\u00e9rie", 
 "Versi\u00f3n hardware": "Vers\u00e3o de hardware", 
 "Ninguno": "Nenhum", 
 "Chino": "Chin\u00eas", 
 "Basic": "B\u00e1sico", 
 "Professional": "Profissional", 
 "Premium": "Pr\u00eamio", 
 "No": "N\u00e3o", 
 "S\u00ed": "Sim", 
 "Cable": "Arame", 
 "Fabricado": "Fabricado", 
 "Asignado": "Atribu\u00eddo", 
 "Terminado": "Finalizado", 
 "Eliminado": "Removido", 
 "Volver": "Retornar", 
 "Plan kiconex": "Plano kiconex", 
 "¡MAC err\u00f3nea!": "MAC errado!", 
 "Introduzca una MAC o IMEI v\u00e1lidos": "Digite um MAC ou IMEI v\u00e1lido", 
 "Generar UUID": "Gerar UUID", 
 "¡SSID err\u00f3neo!": "SSID errado!", 
 "¡UUID err\u00f3neo!": "UUID errado!", 
 "¡ICC err\u00f3neo!": "ICC errado!", 
 "¡N\u00famero de serie err\u00f3neo!": "N\u00famero de s\u00e9rie errado!", 
 "Grupo comercial": "Grupo comercial", 
 "Habilitaci\u00f3n": "Qualifica\u00e7\u00e3o", 
 "F\u00e1brica": "F\u00e1brica", 
 "Administraci\u00f3n": "Administra\u00e7\u00e3o", 
 "Gesti\u00f3n": "Gerenciamento", 
 "Usuarios": "Usu\u00e1rios", 
 "Lista kibox": "Lista kibox", 
 "Lista kiwi": "Lista kiwi", 
 "Kibox asignados": "Kiboxs atribu\u00eddos", 
 "Kiwis asignados": "Kiwis atribu\u00eddos", 
 "No se conecta al WiFi": "N\u00e3o conecta ao Wi-Fi", 
 "Este pedido debe salir con una pegatina extra": "Este pedido deve vir com um adesivo extra", 
 "Cambiar estado de la SIM": "Alterar o estado do SIM", 
 "Estado de la SIM": "Estado do chip", 
 "Fruter\u00eda fulanito": "Verdureiro fulano", 
 "Token actualizado correctamente": "Token atualizado com sucesso", 
 "Usuario creado correctamente": "Usu\u00e1rio criado com sucesso", 
 "No hay respuesta del servidor": "Nenhuma resposta do servidor", 
 "Error": "Erro", 
 "Error al cerrar sesi\u00f3n": "Erro ao sair", 
 "Seleccionar idioma": "Selecione o idioma", 
 "Espa\u00f1ol": "Espanhol", 
 "Ingl\u00e9s": "Ingl\u00eas", 
 "Franc\u00e9s": "Franc\u00eas", 
 "Alem\u00e1n": "Alem\u00e3o", 
 "Portugu\u00e9s": "Portugu\u00eas", 
 "Italiano": "Italiano", 
 "UUID": "UUID", 
 "Nombre comercial": "Nome comercial", 
 "Pedido comercial": "Ordem comercial", 
 "N\u00famero de serie comercial": "N\u00famero de s\u00e9rie comercial", 
 "Modelo del equipo": "Modelo do equipamento", 
 "Estado Comercial": "Status Comercial", 
 "Fecha Conexi\u00f3n": "Conex\u00e3o de data", 
 "Subscripci\u00f3n": "Inscri\u00e7\u00e3o", 
 "Comercial": "Comercial", 
 "General": "Em geral", 
 "Placa borrada correctamente": "Placa apagada com sucesso", 
 "Sistema": "Sistema", 
 "Privilegios": "Privil\u00e9gios", 
 "Roles": "Fun\u00e7\u00f5es", 
 "Usuario borrado correctamente": "Usu\u00e1rio exclu\u00eddo com sucesso", 
 "Cambiar contrase\u00f1a": "Alterar a senha", 
 "Columnas": "Colunas", 
 "Sin informaci\u00f3n": "Sem informa\u00e7\u00e3o", 
 "Cerrar": "Fechar", 
 "Cambiar": "Mudar", 
 "Por favor, seleccione una opcion": "Por favor selecione uma op\u00e7\u00e3o", 
 "¡Las contrase\u00f1as deben coincidir!": "¡As senhas devem corresponder!", 
 "La contrase\u00f1a es un campo obligatorio": "Senha \u00e9 um campo obrigat\u00f3rio", 
 "success": "sucesso", 
 "Contrase\u00f1a actualizada correctamente": "Senha atualizada com sucesso", 
 "Las contrase\u00f1as deben coincidir": "As senhas devem corresponder", 
 "Cambio de contrase\u00f1a usuario": "Altera\u00e7\u00e3o de senha do usu\u00e1rio", 
 "Debe seleccionar un rol": "Voc\u00ea deve selecionar uma fun\u00e7\u00e3o", 
 "Rol creado correctamente": "Fun\u00e7\u00e3o criada com sucesso", 
 "Nuevo Rol": "Novo papel", 
 "Informaci\u00f3n de Rol": "Informa\u00e7\u00f5es da fun\u00e7\u00e3o", 
 "Rol borrado correctamente": "Fun\u00e7\u00e3o exclu\u00edda com sucesso", 
 "Rol administrador": "Fun\u00e7\u00e3o de administrador", 
 "Sincronizar": "Sincronizar", 
 "¡Sincronizar datos!": "¡sincronizar dados!", 
 "Nombre, Organizaci\u00f3n y subscripci\u00f3n van a ser modificados por el valor que tengan en la plataforma Kiconex \u00bfEst\u00e1 seguro de esto?": "Nome, Organiza\u00e7\u00e3o e subscri\u00e7\u00e3o ser\u00e3o modificados pelo valor que t\u00eam na plataforma Kiconex \u00bfTem a certeza disso?", 
 "Usuario guardado correctamente": "Usu\u00e1rio salvo com sucesso", 
 "Nuevo usuario": "Novo usu\u00e1rio", 
 "Editando usuario": "Usu\u00e1rio de edi\u00e7\u00e3o", 
 "Software": "Software", 
 "Crear": "Criar", 
 "Ver": "Ver", 
 "Finalizar": "Terminar", 
 "Editar comercial": "Editar comercial", 
 "Gesti\u00f3n de placas de f\u00e1brica": "Gest\u00e3o de placas de f\u00e1brica", 
 "Asignaciones de f\u00e1brica": "Atribui\u00e7\u00f5es de f\u00e1brica", 
 "Asignaci\u00f3n de placas de f\u00e1brica": "Atribui\u00e7\u00e3o de placas de f\u00e1brica", 
 "Gesti\u00f3n de placas de administraci\u00f3n": "Diretoria de Administra\u00e7\u00e3o", 
 "mykiconex": "mykiconex", 
 "Gesti\u00f3n con plataforma mykiconex": "Gest\u00e3o com plataforma mykiconex", 
 "M2M": "M2M", 
 "Ver M2M": "Ver M2M", 
 "Ver estado": "Ver status", 
 "Ver listado pools": "Ver lista pools", 
 "Refrescar pools": "Atualizar pools", 
 "Actualizar token": "Token de atualiza\u00e7\u00e3o", 
 "VPN": "VPN", 
 "Chat": "Chat", 
 "Ver privilegios": "Ver privil\u00e9gios", 
 "Editar privilegios": "Editar privil\u00e9gios", 
 "Gesti\u00f3n de sistema": "Administra\u00e7\u00e3o de sistema", 
 "Gesti\u00f3n de usuarios": "Gerenciamento de usu\u00e1rios", 
 "Ver acceso a chat": "Ver acesso ao chat", 
 "Ver acceso a soporte": "Ver acesso ao suporte", 
 "Ver acceso a VPN": "Ver Acesso VPN", 
 "Gesti\u00f3n de tarjetas M2M": "Gest\u00e3o de cart\u00f5es M2M", 
 "Autorizaci\u00f3n": "Autoriza\u00e7\u00e3o", 
 "Fecha primera contrataci\u00f3n": "Primeira data de contrata\u00e7\u00e3o", 
 "Fecha \u00faltima renovaci\u00f3n": "\u00daltima data de renova\u00e7\u00e3o", 
 "Intervalo de renovaci\u00f3n (a\u00f1os)": "Intervalo de renova\u00e7\u00e3o (anos)", 
 "Fecha primera conexi\u00f3n": "Primeira data de conex\u00e3o", 
 "Privilegios guardados correctamente": "Privil\u00e9gios salvos corretamente", 
 "Rol actualizado correctamente": "Fun\u00e7\u00e3o atualizada corretamente", 
 "N\u00famero Pedido": "N\u00famero de pedido", 
 "Asunto": "Assunto", 
 "Asignado a": "Atribu\u00eddo a", 
 "Fecha de Creaci\u00f3n": "Data de cria\u00e7\u00e3o", 
 "Pendiente": "Pendente", 
 "Cambiar Estado": "Alterar status", 
 "Estado del Pedido actualizado correctamente": "Encomendar estado atualizado corretamente", 
 "Cliente Final": "Cliente final", 
 "Referencia Presupuesto": "Refer\u00eancia de or\u00e7amento", 
 "Precio Total": "Pre\u00e7o total", 
 "Ver en CRM": "Veja no CRM", 
 "N\u00famero Presupuesto": "N\u00famero do or\u00e7amento", 
 "En Proceso": "Em processo", 
 "Anulado": "Cancelado", 
 "Cambiar estado del pedido": "Alterar o status do pedido", 
 "Pedidos": "Ordens", 
 "Gesti\u00f3n de pedidos": "Gest\u00e3o de pedidos", 
 "Error en la operaci\u00f3n": "Erro de opera\u00e7\u00e3o", 
 "UUID de placa ya en uso": "Placa uuid j\u00e1 em uso", 
 "Nueva Placa Guardada": "Nova placa salva", 
 "Placa actualizada": "Placa atualizada", 
 "Placa borrada": "Placa exclu\u00edda", 
 "Placas actualizadas": "Placas atualizadas", 
 "SSID de kiwi ya en uso": "Kiwi ssid j\u00e1 em uso", 
 "Nuevo KiWi Guardado": "Novo kiwi salvo", 
 "KiWi actualizado": "Kiwi atualizado", 
 "KiWi borrado": "Kiwi exclu\u00eddo", 
 "Token actualizado": "Token atualizado", 
 "Nombre de rol ya en uso": "Nome do papel j\u00e1 em uso", 
 "Rol actualizado": "Fun\u00e7\u00e3o atualizada", 
 "No puede eliminar un rol con dependencias": "N\u00e3o pode eliminar um papel com depend\u00eancias", 
 "La clave ha expirado.": "A chave expirou.", 
 "Usuario no encontrado.": "Usu\u00e1rio n\u00e3o encontrado.", 
 "Las contrase\u00f1as son obligatorias.": "As senhas s\u00e3o obrigat\u00f3rias.", 
 "Las contrase\u00f1as no coinciden.": "As senhas n\u00e3o correspondem.", 
 "Nombre de usuario ya en uso": "Nome de usu\u00e1rio j\u00e1 em uso", 
 "Error del servidor.": "Erro de servidor.", 
 "El usuario no ha sido activado.": "O usu\u00e1rio n\u00e3o foi ativado.", 
 "Inicio de sesi\u00f3n con \u00e9xito": "Login bem-sucedido", 
 "Contrase\u00f1a incorrecta": "Senha incorreta", 
 "Fecha Renovaci\u00f3n": "Data de renova\u00e7\u00e3o", 
 "Tiempo Restante": "Tempo Restante", 
 " meses restantes": " meses restantes", 
 "Pedidos a expirar": "Ordens para expirar", 
 "Descargar Informe": "Download relat\u00f3rio", 
 "Renovaciones": "Reformas", 
 "Pr\u00f3ximo mes": "Pr\u00f3ximo m\u00eas", 
 "Pr\u00f3ximos 3 meses": "Pr\u00f3ximos 3 meses", 
 "Pr\u00f3ximos 6 meses": "Pr\u00f3ximos 6 meses", 
 "Pr\u00f3ximo a\u00f1o": "Pr\u00f3ximo ano", 
 "Ver renovaciones": "Veja reformas", 
 "Caducada": "Expirado", 
 " d\u00edas restantes": "  dias restantes", 
 "Aceptar": "Aceitar", 
 "Reiniciar": "Reiniciar", 
 "Sin organizaci\u00f3n": "Nenhuma organiza\u00e7\u00e3o", 
 "Ver pools": "Veja pools", 
 "Alarmas": "Alarmes", 
 "Alarmas M2M": "Alarmes M2M", 
 "Sin alertas": "Sem alertas", 
 "Advertencia": "Aviso", 
 "Critica": "Critica", 
 "Renovaciones expiradas": "Reformas expiradas", 
 "Pedidos pendientes": "Ordens pendentes", 
 "Tarjetas desactivadas desde hace mas de 12 meses": "Cart\u00f5es desativados por mais de 12 meses", 
 "Ver m\u00e1s": "Ver mais", 
 "Creaci\u00f3n": "Cria\u00e7\u00e3o", 
 "Actualizaci\u00f3n": "Atualizar", 
 "Borrado": "Apagado", 
 "Cambio de estado": "Mudan\u00e7a de status", 
 "Cambio de contrase\u00f1a": "Mudan\u00e7a de senha", 
 "Sincronizaci\u00f3n": "Sincroniza\u00e7\u00e3o", 
 "Sin acci\u00f3n": "Sem a\u00e7\u00e3o", 
 "Fecha": "Data", 
 "Acci\u00f3n": "A\u00e7\u00e3o", 
 "Tipo de objeto": "Tipo de objeto", 
 "Identificador": "Identificador", 
 "Placa": "Placa", 
 "Hace 3 horas": "3 horas atr\u00e1s", 
 "Hace 1 d\u00eda": "1 dia atr\u00e1s", 
 "Hace 3 d\u00edas": "H\u00e1 3 dias", 
 "Hace 1 semana": "1 semana atr\u00e1s", 
 "Actividad": "Atividade", 
 "Listado": "Lista", 
 "Ver actividad": "Veja Atividade", 
 "Privilegio": "Privil\u00e9gio", 
 "No es posible personificar desde un personificado.": "N\u00e3o \u00e9 poss\u00edvel personificar de um personificado.", 
 "Personificaci\u00f3n": "Personifica\u00e7\u00e3o", 
 "Personificando al usuario": "Personificando o usu\u00e1rio", 
 "Volver a la sesi\u00f3n": "V\u00e1 para a sess\u00e3o", 
 "Personificar": "Personificar", 
 "No es posible personificarse a si mismo.": "N\u00e3o \u00e9 poss\u00edvel se personificar.", 
 "Comienzo Personificaci\u00f3n": "In\u00edcio da Personifica\u00e7\u00e3o", 
 "Fin Personificaci\u00f3n": "Personifica\u00e7\u00e3o final", 
 "Ajustes": "Configura\u00e7\u00f5es", 
 "Actualizar listado": "Lista de atualiza\u00e7\u00f5es", 
 "Refrescar pedidos": "Atualizar ordens", 
 "Refrescar ordenes de trabajo": "Atualizar ordens de trabalho", 
 "de": "de", 
 "filtrados de": "filtrado de", 
 "Actualizar listado de organizaciones": "Atualizar lista de organiza\u00e7\u00f5es", 
 "Actualizar nombre, plan y organizaci\u00f3n de kibox": "Atualize o nome, plano e organiza\u00e7\u00e3o de Kibox", 
 "Actualizar listado de pedidos": "Lista de pedidos de atualiza\u00e7\u00e3o", 
 "Actualizar listado de ordenes de trabajo": "Lista de ordens de trabalho de atualiza\u00e7\u00e3o", 
 "Actualizaci\u00f3n de listados": "Atualiza\u00e7\u00e3o da lista", 
 "Actualizado con exito": "Atualizado com sucesso", 
 "Activa": "Ativo", 
 "Sin intervalo": "Sem intervalo", 
 "Mostrar todo": "Mostre tudo", 
 "Estado de suscripci\u00f3n no compatible con el intervalo seleccionado": "Status de assinatura n\u00e3o compat\u00edvel com o intervalo selecionado", 
 "Estado del plan": "Status do plano", 
 "Caducado": "Tempo esgotado", 
 "Inactivo": "Parado", 
 "Cancelado": "Cancelado", 
 "No procede": "N\u00e3o procede", 
 "¡Orden de trabajo erronea!": "Ordem de servi\u00e7o err\u00f4nea!", 
 "Rellene el formulario correctamente": "Preencha o formul\u00e1rio corretamente", 
 "Orden de trabajo": "Ordem de trabalho", 
 "Su sesi\u00f3n va a ser cerrada": "Sua sess\u00e3o ser\u00e1 fechada", 
 "Su sesi\u00f3n se cerrar\u00e1 para aplicar los cambios": "Voc\u00ea ser\u00e1 desconectado para aplicar as altera\u00e7\u00f5es", 
 "Inicie sesi\u00f3n de nuevo": "Fa\u00e7a login novamente", 
 "Posee una versi\u00f3n no compatible": "Tem uma vers\u00e3o n\u00e3o compat\u00edvel", 
 "Consumo": "Consumo", 
 "Consumo de la SIM": "Consumo do SIM", 
 "Mensual": "Por m\u00eas", 
 "Diario": "Di\u00e1rio", 
 "UUID ya en uso": "UUID j\u00e1 em uso", 
 "VPN creada correctamente": "VPN criada com sucesso", 
 "VPN actualizada correctamente": "VPN atualizada com sucesso", 
 "Contrase\u00f1a copiada al portapapeles": "Senha copiada para a \u00e1rea de transfer\u00eancia", 
 "Fallo al copiar la contrase\u00f1a": "Falha ao copiar a senha", 
 "Nueva conexi\u00f3n VPN": "Nova conex\u00e3o VPN", 
 "Regenerar contrase\u00f1a": "Gerar senha novamente", 
 "Contrase\u00f1a VPN": "Senha VPN", 
 "Copie la contrase\u00f1a antes de guardar, no volver\u00e1 a ser visible": "Copie a senha antes de salvar, ela n\u00e3o ficar\u00e1 vis\u00edvel novamente", 
 "VPN (antigua)": "VPN (antigo)", 
 "Ver acceso a VPN (antigua)": "Ver acesso VPN (antigo)", 
 "Ver VPN (antigua)": "Ver VPN (antigo)", 
 "Ver VPN": "Ver VPN", 
 "Crear VPN": "Criar VPN", 
 "Editar VPN": "Editar VPN", 
 "Ver informaci\u00f3n": "Ver informa\u00e7\u00f5es", 
 "Informaci\u00f3n placas": "Informa\u00e7\u00f5es da placa", 
 "Modelo de hardware": "Modelo de hardware", 
 "Fecha de compilaci\u00f3n": "Data de constru\u00e7\u00e3o", 
 "Versi\u00f3n de Daemon": "Vers\u00e3o do daemon", 
 "Fecha de actualizaci\u00f3n": "Data de atualiza\u00e7\u00e3o", 
 "Actualizado": "Atualizada", 
 "No actualizado": "N\u00e3o atualizado", 
 "Descargar fichero de configuraci\u00f3n": "Baixar arquivo de configura\u00e7\u00e3o", 
 "Nunca": "Nunca", 
 "Dispositivo": "Dispositivo", 
 "Router kiconex": "Roteador Kiconex", 
 "Fecha de expedici\u00f3n": "Data de emiss\u00e3o", 
 "\u00bfEst\u00e1 seguro de que desea eliminar este elemento?": "Tem certeza de que deseja excluir este item?", 
 "Confirmaci\u00f3n de eliminaci\u00f3n": "Confirma\u00e7\u00e3o de exclus\u00e3o", 
 "S\u00ed, eliminar": "Sim, excluir", 
 "Cancelar": "Cancelar", 
 "Unidades de cable": "Unidades de cabo", 
 "En espera": "Pendente", 
 "En proceso": "Em processo", 
 "UUID Original": "UUID Original", 
 "El nombre es obligatorio": "O nome é obrigatório", 
 "UUID no v\u00e1lido": "UUID inv\u00e1lido", 
 "API Key borrada": "Chave API eliminada", 
 "La fecha de expiraci\u00f3n debe ser posterior a la fecha actual": "A data de expira\u00e7\u00e3o deve ser posterior \u00e0 data atual", 
 "Clave editada correctamente": "Chave editada com sucesso", 
 "Clave creada correctamente": "Chave criada com sucesso", 
 "Clave copiada al portapapeles": "Chave copiada para a \u00e1rea de transfer\u00eancia", 
 "\u00bfEst\u00e1s seguro?": "Tem a certeza?", 
 "No podr\u00e1s volver a ver esta clave API. \u00bfDeseas continuar?": "N\u00e3o poder\u00e1 voltar a ver esta chave API. Deseja continuar?", 
 "S\u00ed, cerrar": "Sim, fechar", 
 "La clave no volver\u00e1 a estar disponible": "A chave deixar\u00e1 de estar dispon\u00edvel", 
 "\u00bfDeseas borrar esta clave API?": "Deseja eliminar esta chave API?", 
 "S\u00ed, borrar": "Sim, eliminar", 
 "Clave borrada correctamente": "Chave eliminada com sucesso", 
 "Sin descripci\u00f3n": "Sem descri\u00e7\u00e3o", 
 "Fecha de expiraci\u00f3n": "Data de expira\u00e7\u00e3o", 
 "Editar clave API": "Editar chave API", 
 "Nueva clave API": "Nova chave API", 
 "Copiar clave": "Copiar chave", 
 "Clave API creada correctamente": "Chave API criada com sucesso", 
 "Esta es tu clave API. No podr\u00e1s volver a consultarla en el futuro, c\u00f3piala y \u00fasala donde necesites": "Esta \u00e9 a sua chave API. N\u00e3o poder\u00e1 consult\u00e1-la novamente no futuro, por isso copie-a e utilize-a onde for necess\u00e1rio", 
 "Claves API": "Chaves API", 
 "Listado de claves API": "Lista de chaves API", 
 "Generar nueva clave": "Gerar nova chave", 
 "Editar claves": "Editar chaves", 
 "Editar tracker": "Editar tracker", 
 "Modelo control": "Modelo control", 
 "Clave API control": "Chave API control", 
 "Clave API box": "Chave API box", 
 "Actualizar claves de acceso para: ": "Aggiorna le chiavi di accesso per: ", 
 "Traductor de librer\u00edas": "Tradutor de bibliotecas", 
 "Estado de subscripci\u00f3n": "Estado da subscri\u00e7\u00e3o", 
 "Versi\u00f3n": "Vers\u00e3o", 
 "Sin versi\u00f3n": "Sem vers\u00e3o", 
 "Sin modelo": "Sem modelo", 
 "Primero seleccione un modelo": "Primeiro selecione um modelo", 
 "Tendr\u00e1 que volver a iniciar sesi\u00f3n para usar la nova chave": "Voc\u00ea precisar\u00e1 fazer login novamente para usar a nova chave", 
 "El nombre de usuario es un campo obligatorio": "Nome de usu\u00e1rio \u00e9 um campo obrigat\u00f3rio", 
 "Pedido es un campo obligatorio": "Pedido \u00e9 um campo obrigat\u00f3rio", 
 "UUID es un campo obligatorio": "UUID \u00e9 um campo obrigat\u00f3rio", 
 "Modelo y versi\u00f3n son campos obligatorios": "Modelo e vers\u00e3o s\u00e3o campos obrigat\u00f3rios", 
 "Renovaciones M2M expiradas": "Renova\u00e7\u00f5es M2M expiradas", 
 "Renovaciones de plan expiradas": "Renova\u00e7\u00f5es de plano expiradas", 
 "Ingrese el n\u00famero de meses": "Insira o n\u00famero de meses", 
 "Intervalo de renovaci\u00f3n": "Intervalo de renova\u00e7\u00e3o", 
 "suscripci\u00f3n": "assinatura", 
 "suscripciones": "assinaturas", 
 "Editando": "Editando", 
 "Renovando": "Renovando", 
 "suscripciones actualizadas correctamente": "assinaturas atualizadas com sucesso", 
 "Pr\u00f3xima renovaci\u00f3n": "Pr\u00f3xima renova\u00e7\u00e3o", 
 "Renovar": "Renovar", 
 "\u00bfD\u00f3nde encuentro mi clave?": "Onde encontro minha chave?", 
 "Clave API Cloud": "Chave API Cloud", 
 "Clave API Cloud actualizada correctamente": "Chave API Cloud atualizada com sucesso", 
 "VPN Antigua": "VPN antigo", 
 "Meses a renovar": "Meses para renovar", 
 "Debe seleccionar un estado de suscripci\u00f3n": "Voc\u00ea deve selecionar um status de assinatura", 
 "Plan es obligatorio": "O plano \u00e9 obrigat\u00f3rio", 
 "Debe seleccionar un estado de suscripci\u00f3n M2M": "Voc\u00ea deve selecionar um status de assinatura M2M", 
 "ICC es obligatorio": "ICC \u00e9 obrigat\u00f3rio", 
 "Hist\u00f3rico de suscripci\u00f3n": "Hist\u00f3rico de assinatura", 
 "Fecha de primera conexi\u00f3n": "Data da Primeira Conex\u00e3o", 
 "Fecha de renovaci\u00f3n": "Data de Renova\u00e7\u00e3o", 
 "meses": "meses", 
 "Realizado por": "Realizado por", 
 "Eliminaci\u00f3n": "Elimina\u00e7\u00e3o", 
 "Cancelaci\u00f3n": "Cancelamento", 
 "Preparaci\u00f3n": "Prepara\u00e7\u00e3o", 
 "Cambio de intervalo": "Altera\u00e7\u00e3o de intervalo", 
 "Cambio de plan": "Altera\u00e7\u00e3o do Plano", 
 "Caducadas": "Expiradas", 
 "Por vencer": "Pr\u00f3ximas", 
 "Cargando": "Carregando", 
 "Gestionar perfil": "Gerenciar perfil", 
 "Instalaci\u00f3n original": "Instala\u00e7\u00e3o original", 
 "Actualizar en Kite": "Atualizar no Kite", 
 "Debe seleccionar una suscripci\u00f3n de plan": "Voc\u00ea deve selecionar uma assinatura de plano", 
 "Propietario": "Propriet\u00e1rio", 
 "Tarifa": "Tarifa", 
 "Nueva fecha": "Nova data", 
 "Error al crear usuario": "Erro ao criar usu\u00e1rio", 
 "Error al obtener datos": "Erro ao obter dados", 
 "Error al cargar las claves API": "Erro ao carregar chaves API", 
 "Error al guardar la clave": "Erro ao salvar chave", 
 "Error al borrar la clave": "Erro ao apagar chave", 
 "Error al editar la clave": "Erro ao editar chave", 
 "Error al copiar la clave": "Erro ao copiar chave", 
 "No puedes cambiar la fecha de expiraci\u00f3n una vez creada": "N\u00e3o pode mudar a data de expira\u00e7\u00e3o uma vez criada", 
 "No se puede devolver a Stock: la placa tiene repuestos asignados": "N\u00e3o \u00e9 poss\u00edvel devolver ao Stock: a placa tem pe\u00e7as de substitui\u00e7\u00e3o atribu\u00eddas", 
 "Introduzca su correo electr\u00f3nico": "Insira o seu endere\u00e7o de e-mail", 
 "Si el correo existe, recibir\u00e1 un mensaje con instrucciones para restablecer su contrase\u00f1a.": "Se o e-mail existir, receber\u00e1 uma mensagem com instru\u00e7\u00f5es para redefinir a sua senha.", 
 "Enviar enlace de recuperaci\u00f3n": "Enviar link de recupera\u00e7\u00e3o", 
 "Volver al inicio de sesi\u00f3n": "Voltar ao login", 
 "Nueva contrase\u00f1a": "Nova senha", 
 "Restablecer contrase\u00f1a": "Redefinir senha", 
 "El enlace de recuperaci\u00f3n ha caducado o ya ha sido utilizado. Solicite uno nuevo.": "O link de recupera\u00e7\u00e3o expirou ou j\u00e1 foi utilizado. Solicite um novo.", 
 "Error al restablecer la contrase\u00f1a": "Erro ao redefinir a senha", 
 "\u00bfOlvid\u00f3 su contrase\u00f1a?": "Esqueceu a sua senha?", 
 "Su contrase\u00f1a ha caducado": "A sua senha expirou", 
 "Han pasado m\u00e1s de 6 meses desde el \u00faltimo cambio. Por motivos de seguridad debe establecer una nueva contrase\u00f1a antes de continuar.": "J\u00e1 passaram mais de 6 meses desde a \u00faltima altera\u00e7\u00e3o. Por raz\u00f5es de seguran\u00e7a, deve definir uma nova senha antes de continuar.", 
 "Entendido": "Entendido", 
 "La contrase\u00f1a debe tener al menos 12 caracteres.": "A senha deve ter pelo menos 12 caracteres.", 
 "La contrase\u00f1a debe incluir al menos tres de las siguientes categor\u00edas: may\u00fasculas, min\u00fasculas, n\u00fameros y caracteres especiales.": "A senha deve incluir pelo menos tr\u00eas das seguintes categorias: mai\u00fasculas, min\u00fasculas, n\u00fameros e caracteres especiais.", 
 "Cambiar ahora": "Alterar agora", 
 "Su contrase\u00f1a caducar\u00e1 pronto": "A sua senha ir\u00e1 expirar em breve", 
 "Le quedan {days} d\u00edas para cambiar su contrase\u00f1a. Pulse el bot\u00f3n para hacerlo ahora.": "Tem {days} dia(s) restante(s) para alterar a sua senha. Clique no bot\u00e3o para o fazer agora.", 
 "copiado al portapapeles": "copiado para a \u00e1rea de transfer\u00eancia",
 "C\u00f3digos copiados al portapapeles": "Códigos de recuperação copiados para a área de transferência",
 "C\u00f3digos de recuperaci\u00f3n": "Códigos de recuperação",
 "Gu\u00e1rdelos en un lugar seguro. No se volver\u00e1n a mostrar. Cada uno sirve una sola vez si pierde el acceso a su aplicaci\u00f3n.": "Guarde-os em um local seguro. Não serão exibidos novamente. Cada um pode ser usado uma vez se perder acesso ao seu aplicativo.",
 "Copiar c\u00f3digos": "Copiar códigos",
 "Introduzca el c\u00f3digo": "Digite o código",
 "C\u00f3digo incorrecto": "Código incorreto",
 "Verificaci\u00f3n en dos pasos desactivada": "Verificação em duas etapas desabilitada",
 "Verificaci\u00f3n en dos pasos": "Verificação em duas etapas",
 "Introduzca uno de sus c\u00f3digos de recuperaci\u00f3n para desactivar la verificaci\u00f3n en dos pasos.": "Introduza um dos seus códigos de recuperação para desativar a verificação em duas etapas.",
 "C\u00f3digo de recuperaci\u00f3n": "Código de recuperação",
 "Desactivar 2FA": "Desativar 2FA",
 "Usar el c\u00f3digo de la aplicaci\u00f3n": "Usar o código da aplicação",
 "\u00bfNo tiene acceso a la app? Usar un c\u00f3digo de recuperaci\u00f3n": "Não tem acesso à aplicação? Usar um código de recuperação",
 "Su cuenta est\u00e1 protegida con un segundo factor. Para desactivarlo, introduzca un c\u00f3digo de su aplicaci\u00f3n de autenticaci\u00f3n.": "Sua conta está protegida com um segundo fator. Para desativá-lo, digite um código do seu aplicativo de autenticação.",
 "\u00d1ade una capa extra de seguridad. Necesitar\u00e1 una app como Google Authenticator para generar los c\u00f3digos.": "Adicione uma camada extra de segurança. Você precisará de um aplicativo como Google Authenticator para gerar os códigos.",
 "1. Escanee el c\u00f3digo QR con su aplicaci\u00f3n de autenticaci\u00f3n": "1. Escaneie o código QR com seu aplicativo de autenticação",
 "\u00bfNo puede escanear? Introduzca esta clave manualmente": "Não consegue digitalizar? Digite esta chave manualmente",
 "2. Introduzca el c\u00f3digo de 6 d\u00edgitos que muestra la app": "2. Digite o código de 6 dígitos exibido pelo aplicativo",
 "Su contrase\u00f1a ha caducado": "Sua senha expirou",
 "Error al obtener datos": "Erro ao obter dados",
 "Error al copiar": "Falha ao copiar",
 "Tarifa es obligatorio": "A tarifa \u00e9 obrigat\u00f3ria",
 "M2M actualizado correctamente": "M2M atualizado com sucesso",
 "Error al actualizar M2M": "Erro ao atualizar M2M",
 "Enlace no v\u00e1lido o expirado. P\u00eddalo de nuevo o p\u00f3ngase en contacto con un administrador.": "Link inv\u00e1lido ou expirado. Solicite novamente ou entre em contato com um administrador.",
 "Datos personales": "Dados pessoais",
 "Seguridad y acceso": "Seguran\u00e7a e acesso",
 "Zona horaria": "Fuso hor\u00e1rio",
 "Seleccione una zona horaria": "Selecione um fuso hor\u00e1rio",
 "Sin instalaci\u00f3n": "Sem instala\u00e7\u00e3o",
 "Cambiar clave API Cloud": "Alterar a chave API Cloud",
 "Librerías": "Bibliotecas",
 "Plantillas": "Modelos",
 "No tiene configurada una clave API Cloud": "Não tem uma chave API Cloud configurada",
 "El traductor de librerías necesita su clave API Cloud para acceder a las librerías.": "O tradutor de bibliotecas necessita da sua chave API Cloud para aceder às bibliotecas.",
 "Configurar clave": "Configurar chave",
 "UUID copiado al portapapeles": "UUID copiado para a área de transferência",
 "Error al copiar el UUID": "Erro ao copiar o UUID",
 "Idioma por defecto": "Idioma predefinido",
 "Traducir": "Traduzir",
 "Copiar UUID": "Copiar UUID",
 "Traducir con IA": "Traduzir com IA",
 "Elija un contexto para poder traducir": "Escolha um contexto para poder traduzir",
 "Parámetro": "Parâmetro",
 "origen": "origem",
 "librería": "biblioteca",
 "plantilla": "modelo",
 "Contexto de traducción": "Contexto de tradução",
 "con error": "com erro",
 "cancelando…": "a cancelar…",
 "pausando…": "a pausar…",
 "en pausa": "em pausa",
 "Guardar y cerrar": "Guardar e fechar",
 "Traducir todo": "Traduzir tudo",
 "Traducir seleccionadas": "Traduzir selecionadas",
 "Pausar": "Pausar",
 "Continuar": "Continuar",
 "El texto en el idioma origen está vacío": "O texto no idioma de origem está vazio",
 "No se ha podido traducir": "Não foi possível traduzir",
 "Falta configurar la URL del WebSocket del traductor": "Falta configurar o URL do WebSocket do tradutor",
 "No hay traducciones pendientes": "Não há traduções pendentes",
 "No quedan traducciones pendientes": "Não restam traduções pendentes",
 "Traducción en pausa": "Tradução em pausa",
 "Traducción cancelada": "Tradução cancelada",
 "Traducción terminada": "Tradução concluída",
 "Error en el proceso de traducción": "Erro no processo de tradução",
 "Corrija las traducciones no válidas antes de guardar": "Corrija as traduções inválidas antes de guardar",
 "Traducciones guardadas": "Traduções guardadas",
 "No se han podido guardar las traducciones": "Não foi possível guardar as traduções",
 "No se han podido cargar los parámetros de la librería": "Não foi possível carregar os parâmetros da biblioteca",
 "La traducción no puede superar los {max} caracteres": "A tradução não pode exceder {max} caracteres",
 "La traducción contiene caracteres no válidos": "A tradução contém caracteres inválidos",
 "La traducción por defecto no puede estar vacía": "A tradução predefinida não pode estar vazia",
 "Clave API Cloud no válida": "Chave API Cloud inválida",
 "Revise su clave API Cloud para poder usar el traductor de librerías.": "Verifique a sua chave API Cloud para poder utilizar o tradutor de bibliotecas.",
 "Revisar clave": "Verificar chave",
 "cambios sin guardar": "alterações não guardadas",
 "Acceso al traductor de librerías": "Acesso ao tradutor de bibliotecas",
 "sólo no válidas": "apenas inválidas",
 "No tiene permiso para modificar esta librería": "Não tem permissão para modificar esta biblioteca",
 "Asignar router": "Atribuir roteador",
 "Contraseña del dispositivo": "Senha do dispositivo",
 "Crear box": "Criar box",
 "Crear router": "Criar roteador",
 "Duplicado": "Duplicado",
 "El modem ya no está disponible": "O modem já não está disponível",
 "Este dispositivo no tiene ningún modem Teltonika asociado": "Este dispositivo não tem nenhum modem Teltonika associado",
 "Este dispositivo no tiene ningún router kiconex asignado": "Este dispositivo não tem nenhum roteador Kiconex atribuído",
 "Exportar a Excel": "Exportar para Excel",
 "Falta el número de serie": "Falta o número de série",
 "Falta la MAC": "Falta o MAC",
 "Falta la contraseña": "Falta a senha",
 "Fecha alta": "Data de criação",
 "Fichero": "Ficheiro",
 "Fila": "Linha",
 "IMEI no válido": "IMEI inválido",
 "Importar": "Importar",
 "Importar modems": "Importar modems",
 "Información de modem": "Informações do modem",
 "Información de router": "Informações do roteador",
 "Libres": "Livres",
 "MAC no válida": "MAC inválido",
 "Modem": "Modem",
 "Modem Teltonika": "Modem Teltonika",
 "Modem borrado correctamente": "Modem eliminado com sucesso",
 "Modem es un campo obligatorio": "Modem é um campo obrigatório",
 "Modems importados": "Modems importados",
 "No se ha podido cargar la información del router": "Não foi possível carregar as informações do roteador",
 "No se ha podido leer el fichero": "Não foi possível ler o ficheiro",
 "Nuevo modem": "Novo modem",
 "Nuevo repuesto": "Nova peça de reposição",
 "Nuevo router": "Novo roteador",
 "Observaciones": "Observações",
 "Organización es un campo obligatorio": "Organização é um campo obrigatório",
 "Repetido en el fichero": "Repetido no ficheiro",
 "Revisa los campos marcados": "Reveja os campos assinalados",
 "Router": "Roteador",
 "Router (dato antiguo)": "Roteador (dado antigo)",
 "Router borrado correctamente": "Roteador eliminado com sucesso",
 "Router no disponible": "Roteador não disponível",
 "Router terminado": "Roteador finalizado",
 "Seleccionar fichero": "Selecionar ficheiro",
 "Seleccionar router": "Selecionar roteador",
 "Sin modem Teltonika": "Sem modem Teltonika",
 "Sin tipo": "Sem tipo",
 "Stock Kiconex": "Stock Kiconex",
 "Stock Teltonika": "Stock Teltonika",
 "Tipo": "Tipo",
 "Tipo Teltonika": "Tipo Teltonika",
 "Tracker": "Tracker",
 "Transformados": "Transformados",
 "UUID router": "UUID do roteador",
 "Versión placa": "Versão da placa",
 "Válido": "Válido",
 "Ya existe en el sistema": "Já existe no sistema",
 "duplicadas": "duplicadas",
 "filas leídas": "linhas lidas",
 "válidas": "válidas",
 "¡IMEI erróneo!": "IMEI errado!",
 "Lista routers": "Lista routers",
 "Routers asignados": "Routers atribuídos",
 "Seleccionar ICC": "Selecionar ICC",
  "Se deben renovar al menos": "É necessário renovar pelo menos",
},
  "plural": "(n != 1)"
  };
